import { useContext } from "react";
import {
  ANONYMOUS_SESSION_FALLBACK,
  AnonymousSessionContext,
} from "./AnonymousSessionContext";

// Falls back to ANONYMOUS_SESSION_FALLBACK outside the provider — the provider
// is only mounted on anonymous-allowed routes (see PrivateRoute), so every
// other consumer needs a safe default.
export const useAnonymousSession = () =>
  useContext(AnonymousSessionContext) ?? ANONYMOUS_SESSION_FALLBACK;
